import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import(/* webpackChunkName: "login" */ "src/pages/Login/Login"),
  },
  {
    path: "/reset-password",
    component: () => import(/* webpackChunkName: "reset-password" */ "src/pages/ResetPassword/ResetPassword"),
    children: [
      {
        path: "",
        name: "ResetPasswordForm",
        component: () => import(/* webpackChunkName: "reset-password-form" */ "src/pages/ResetPassword/ResetPasswordForm"),
      },
      {
        path: "success",
        name: "ResetPasswordSuccess",
        component: () => import(/* webpackChunkName: "reset-password-success" */ "src/pages/ResetPassword/ResetPasswordSuccess"),
      },
      {
        path: "error",
        name: "ResetPasswordError",
        component: () => import(/* webpackChunkName: "reset-password-error" */ "src/pages/ResetPassword/ResetPasswordError"),
      },
    ],
  },
  {
    path: "/verify",
    component: () => import(/* webpackChunkName: "strong-password" */ "src/pages/StrongPassword/StrongPassword"),
    children: [
      {
        path: "",
        name: "StrongPasswordForm",
        component: () => import(/* webpackChunkName: "strong-password-form" */ "src/pages/StrongPassword/StrongPasswordForm"),
      },
      {
        path: "success",
        name: "StrongPasswordSuccess",
        component: () => import(/* webpackChunkName: "strong-password-success" */ "src/pages/StrongPassword/StrongPasswordSuccess"),
      },
      {
        path: "error",
        name: "StrongPasswordError",
        component: () => import(/* webpackChunkName: "strong-password-error" */ "src/pages/StrongPassword/StrongPasswordError"),
      },
    ],
  },
  {
    path: "*",
    name: "Error404",
  },
]

const router = new VueRouter({
  mode: "history",
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.name === "Error404") {
    next("/")
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js